// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class BankAccountTypes {
    public static readonly CHECKING: string = 'Checking';
    public static readonly SAVING: string = 'Saving';
    public static readonly CD: string = 'CD';
    public static readonly OTHER: string = 'Other';
}
